import {isString} from './isString';

export function isStringEnum<T extends object>(o?: any): o is T {
    const values = Object.values(o);
    return !values.length || values.every(isString);
}
